/* Validara roles y activara los permisos para las vistas */
import {panelController} from "./../../stores/service";

import { writable } from "svelte/store";

import { navigate } from "svelte-routing";

import { validService } from "./../../Models/views/modelLogin";

import { modelValid } from "./../../Models/modelSystemG";

import { crearUser, createMuestras } from "./../../Models/user/newUser";


export async function loginService(user) {

  /* let statusCuenta = await validService('cafeartesaniaspalua@gmail.com'); */  

  /* http://localhost:5000/?id=6918536776&key=14671 
     http://localhost:5000/?id=8141041975&key=48479
  */

 
  /* http://localhost:5000/?id=7392&key=7423 */
  let statusCuenta = await validService(user.email);  
 /*  CrearAnalytics() */

  if (statusCuenta.data.length > 0 &&  statusCuenta.status && statusCuenta.dataBlock == false) {
    /* usuarioRegistrado */
    inicializarService(statusCuenta.data, user.email);
  } 
  
}

export async function crearCuenta(user) {
  let services = await crearUser(user);

  if (services.status) {
    inicializarService([{doc:services.data.data,id:services.data.id}],user.email);
  } else {
    inicializarvistas('login');
  }
}

export function inicializarService(data, user) {
  
  panelController.update((values) => {
    /* registrar datos al sistema */
    values.service = data[0].doc;
    values.firebase.docs[0].id = data[0].id;

    /* validar admin */
    if (data[0].doc.tableadmins[0].email == user) {
      /* admin */
      user = "admin";
      
    } else {
      /* colaborador */
      user = "colaborador";
    }

    if (data[0].doc.service.super) {
      user = "super";
    }
    
    /* validar datos de firebase */
    values.viewLogin.roluser = 1;
    values.firebase.load = true;
    values.viewLogin.status = true;

    values.viewLogin.user = user;
    return values;
  });
      /* iniciarvistas */

    ValidView('admin');
    inicializarvistas('admin')
    navigate("/mesas", { replace: true });
}

export function statuslogin(data){
  ValidView(data);
}

export function ValidView(rol) {
  panelController.update((value) => {
    value.viewCE.nav = false;
    value.viewConfiguracion.nav = false;
    value.viewMenu.nav = false;
    value.viewLogin.nav = false;
    value.viewMainRatinggs.nav = false;
    value.viewOrdenar.nav = false;
    value.viewDashboard.nav = false;
    value.viewPanel.nav = false;
    value.viewPerfil.nav = false;
    value.viewSondeosPanel.nav = false;
    value.viewMembresias.nav = false;

    switch (rol) {
      case "admin":
        value.viewLogin.nav = true;
        value.viewMainRatinggs.nav = true;
        value.viewConfiguracion.nav = true;
        value.viewMenu.nav = true;
        value.viewPanel.nav = true;
        value.viewPerfil.nav = true;

        if (value.service.service.mode == 1) {
          value.viewMesas.nav = true;
        }
        if (value.service.service.mode == 2) {
        }

        break;
      case "nuevoUsuario":
        value.viewLogin.nav = true;
        value.viewConfiguracion.nav = true;
        value.viewPerfil.nav = true;
        break;
      case "login":
        value.viewLogin.nav = false;

        break;
      case "colaborador":
        value.viewLogin.nav = true;
        value.viewMainRatinggs.nav = true;
        value.viewPanel.nav = true;
        value.viewPerfil.nav = true;
        break;

      case "muestra":
        break;

      case "Super admin":
        value.viewLogin.nav = true;
        value.viewConfiguracion.nav = true;
        value.viewMenu.nav = true;
        value.viewPanel.nav = true;
        value.viewPerfil.nav = true;
        value.viewMembresias.nav = true;
        break;

      default:
        /* error */
        break;
    }

    return value;
  });
}

export function inicializarvistas(rol,user){
  switch (rol) {
    case "admin":
     
    /* viewMainRatinggs */

    /* viewConfiguracion */

    /* viewPerfil 
    http://localhost:5000/?id=7392&key=7423&idmesa=1
    https://ratingg.com.mx/?id=7392&key=7423&idmesa=1
    */



      
      /* viewMesas */
     /*  if (value.service.service.mode == 1) {
        
      } */


      break;
    case "nuevoUsuario":
      /* Aceptar terminos y condiciones */

      /* 
      viewConfiguracion
      viewPerfil
      */


      ValidView(rol);
     crearCuenta(user);
     
      break;
    case "login":
      ValidView("login");
    /* viewLogin */
    estadoLogin();

    navigate("/", { replace: true });
    

      break;
    case "colaborador":

    /* viewMainRatinggs */

    /* viewPanel */
    /* viewPerfil */
      break;

    case "muestra":
      relatimeService()
      /* EVALUACION */
      
      estadoEvaluacion()
/*       iniciarEvaluacion(); */
      break;

    case "Super admin":
      /* viewMainRatinggs */

    /* viewConfiguracion */

    /* viewPerfil */

    /* viewMembresias */
      
      break;

    default:
      /* error */
      break;
  }
}

function estadoLogin() {
  panelController.update((values) => {

    values.viewLogin.controllers.txt.mess =
    "Inicia sesión para enviar el ratingg";
  values.viewLogin.controllers.btn[0].status = true;
  values.viewLogin.controllers.btn[1].status = false;
  values.viewLogin.controllers.btn[2].status = false;
  values.firebase.load = true;
    return values;
  });

}

function estadoEvaluacion() {
  panelController.update((values) => {

    values.viewLogin.controllers.txt.mess =
    `Servicio`;
  values.viewLogin.controllers.btn[0].status = false;
  values.viewLogin.controllers.btn[1].status = false;
  values.viewLogin.controllers.btn[2].status = false;
  values.firebase.load = true;
    return values;
  });

}

